var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/shift-attendance.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-22644db6!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/shift-attendance.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ShiftAttendance.vue
// module id = 715
// module chunks = 1